import instance from 'utils/axios/instance.axios';
import { PROPOSALS } from './_constant';

export const createProposal = (data) => instance.post('/proposals', data);

export const updateProposal = ({ id, data }) => instance.patch(`/proposals/${id}`, data);

export const getAllProposal = (pagination, filters) =>
  instance.get('/proposals', { params: { ...pagination, ...filters } });

export const getProposalById = (id) => instance.get(`/proposals/${id}`);

export const deleteProposal = ({ id }) => instance.delete(`/proposals/${id}`);

export const approveProposal = (id) => instance.patch(`/proposals/approve/${id}`);

export const downloadFile = (path) =>
  instance.post(PROPOSALS.DOWNLOAD_FILE, path, { responseType: 'blob' });

export const updateProposalStatus = ({ id, data }) =>
  instance.patch(`/proposals/${id}/status`, data);

export const downloadZip = (data = {}) =>
  instance.post('proposals/download-zip', data, { responseType: 'blob' });

export const uploadProposalFile = ({ id, data }) => instance.post(PROPOSALS.UPLOAD_FILE(id), data);

export const changeProgram = (data) => {
  const { proposalId, proposalProgramId } = data;

  return instance.patch(PROPOSALS.CHANGE_PROGRAM(proposalId), { proposalProgramId });
};
